import { render, staticRenderFns } from "./ReporteUsuario.vue?vue&type=template&id=27b70df2"
import script from "./ReporteUsuario.vue?vue&type=script&lang=js"
export * from "./ReporteUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports